// extracted by mini-css-extract-plugin
module.exports = {"chart":"barChart_chart__t-xSM"};